import { ReactNode } from 'react';
import styled from 'styled-components';

interface MenuTitleProps {
  children?: ReactNode;
}

export const MenuTitle = styled.span<MenuTitleProps>`
  margin-left: 5px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.neutral.dark};
`;

interface MenuWrapperProps {
  children?: ReactNode;
  style?: any;
}

export const MenuWrapper = styled.div<MenuWrapperProps>`
  overflow: hidden;
  transition: height 0.4s ease-in-out;

  @media (min-width: 992px) {
    height: auto !important;
    width: 100%;
  }
`;

interface ToggleButtonProps {
  children?: ReactNode;
  onClick?: any;
}

export const ToggleButton = styled.a<ToggleButtonProps>`
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
  display: block;
  padding: 15px 30px;

  @media (min-width: 992px) {
    display: none;
  }

  &:hover {
    cursor: pointer;
  }
`;

interface ContainerProps {
  children?: ReactNode;
  ref?: any;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;

  @media (min-width: 992px) {
    overflow: hidden;
  }

  @media (max-width: 991px) {
    height: auto;
  }
`;

interface NavWrapperProps {
  children?: ReactNode;
}

export const NavWrapper = styled.div<NavWrapperProps>`
  display: flex;
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
  padding: 0 10px;

  @media (min-width: 992px) {
    border-right: ${({ theme }) => `1px solid ${theme.palette.backgrounds.main}`};
    flex: 0 0 350px;
  }

  @media (max-width: 991px) {
    flex-direction: column;
    width: 100%;
  }
`;
